function CreateSegmentModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.restrictType = ctrl.resolve.restrictType;
    if (ctrl.restrictType === 'TEXT') {
      ctrl.streamTypes = [{id: 2, name: 'AUDIO'}];
    } else if (ctrl.restrictType === 'AUDIO') {
      ctrl.streamTypes = [{id: 1, name: 'TEXT'}];
    } else {
      ctrl.streamTypes = stateService.getStreamTypes();
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.segment });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('CreateSegmentModalController', CreateSegmentModalController);
